import { Hidden, makeStyles, MenuList } from "@material-ui/core";
import { FullscreenModal } from "../../modals/fullscreen/FullscreenModal";

export const ResponsiveMenu = ({ isMobile, ...props }) => {
  const classes = menuStyles();
  if (isMobile) {
    return (
      <FullscreenModal isOpen={props.open} onClose={props.onClose}>
        {props.children}
      </FullscreenModal>
    );
  }
  return (
    <Hidden smDown>
      <MenuList className={classes.root}>{props.children}</MenuList>
    </Hidden>
  );
};

const menuStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("md")]: {
      "& > li": {
        display: "inline-flex",
        minWidth: "auto",
        backgroundColor: "transparent",
      },
      display: "flex",
      justifyContent: "end",
    },
    padding: 0,
    width: "100%",
  },
}));
